// extracted by mini-css-extract-plugin
export default {"overlay":"OverlayLoading_overlay__d26E-","loading":"OverlayLoading_loading__dZbVq"};